module.exports = __webpack_public_path__ + "media/wyposazenie/kola-9847dd73.png";